var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _rect11, _rect12, _path2, _g, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _g2, _text10, _circle, _g3, _text11, _circle2, _g4, _text12, _circle3, _g5, _text13, _circle4, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _text14, _rect13, _g15, _path3, _path4, _path5, _path6, _path7, _path8, _rect14, _path9, _rect15, _g16, _rect16, _rect17, _g17, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 834.89,
    height: 395.775,
    viewBox: "0 0 834.89 395.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.362,
    y1: 0.5,
    x2: 4.134,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0071bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -8.342,
    y1: 0.5,
    x2: -0.406,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.867,
    y1: 0.5,
    x2: 0.36,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2.918,
    y1: 0.5,
    x2: 0.15,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2.235,
    y1: 0.5,
    x2: 0.22,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.934,
    y1: 0.5,
    x2: 4.591,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2.939,
    y1: 0.5,
    x2: 6.281,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -5.653,
    y1: 0.5,
    x2: -0.131,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f44522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2.189,
    y1: 0.5,
    x2: 0.224,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2.782,
    y1: 0.5,
    x2: 0.164,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.252,
    y1: 0.719,
    x2: 0.026,
    y2: 0.522,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -170.674,
    y1: -35.998,
    x2: -168.752,
    y2: -35.998,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -166.592,
    y1: -14.474,
    x2: -161.684,
    y2: -14.474,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.714,
    y1: 0.523,
    x2: 0.882,
    y2: 0.5,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe3c38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#fe3c38",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#fe3c38",
    stopOpacity: 0.957
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.459,
    stopColor: "#fe3c38",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.562,
    stopColor: "#fe3c38",
    stopOpacity: 0.816
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#fe3c38",
    stopOpacity: 0.706
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#fe3c38",
    stopOpacity: 0.576
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fe3c38",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "#fe3c38",
    stopOpacity: 0.235
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#fe3c38",
    stopOpacity: 0.035
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe3c38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -1.004,
    y1: 0.5,
    x2: 0.346,
    y2: 0.5,
    xlinkHref: "#linear-gradient-8"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_265",
    "data-name": "\\uC0AC\\uAC01\\uD615 265",
    width: 11,
    height: 48,
    transform: "translate(332.162 45.234) rotate(90)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_266",
    "data-name": "\\uC0AC\\uAC01\\uD615 266",
    width: 11,
    height: 194,
    transform: "translate(283.162 45.234) rotate(90)",
    fill: "url(#linear-gradient-2)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_267",
    "data-name": "\\uC0AC\\uAC01\\uD615 267",
    width: 11,
    height: 30,
    transform: "translate(169.162 305.234) rotate(90)",
    fill: "url(#linear-gradient-3)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_268",
    "data-name": "\\uC0AC\\uAC01\\uD615 268",
    width: 11,
    height: 75,
    transform: "translate(138.162 305.234) rotate(90)",
    fill: "url(#linear-gradient-4)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_269",
    "data-name": "\\uC0AC\\uAC01\\uD615 269",
    width: 11,
    height: 60,
    transform: "translate(346.162 88.234) rotate(90)",
    fill: "url(#linear-gradient-5)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_270",
    "data-name": "\\uC0AC\\uAC01\\uD615 270",
    width: 11,
    height: 92,
    transform: "translate(585.162 88.234) rotate(90)",
    fill: "url(#linear-gradient-6)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_271",
    "data-name": "\\uC0AC\\uAC01\\uD615 271",
    width: 11,
    height: 130,
    transform: "translate(497.162 88.234) rotate(90)",
    fill: "url(#linear-gradient-7)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_272",
    "data-name": "\\uC0AC\\uAC01\\uD615 272",
    width: 11,
    height: 135,
    transform: "translate(549.162 305.234) rotate(90)",
    fill: "url(#linear-gradient-8)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_273",
    "data-name": "\\uC0AC\\uAC01\\uD615 273",
    width: 11,
    height: 59,
    transform: "translate(765.162 88.234) rotate(90)",
    fill: "url(#linear-gradient-9)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_274",
    "data-name": "\\uC0AC\\uAC01\\uD615 274",
    width: 11,
    height: 72,
    transform: "translate(702.162 88.234) rotate(90)",
    fill: "url(#linear-gradient-10)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2466",
    "data-name": "\\uD328\\uC2A4 2466",
    d: "M562.87,9950.019h-96v190h11v-179h85Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "url(#linear-gradient-11)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_275",
    "data-name": "\\uC0AC\\uAC01\\uD615 275",
    width: 11,
    height: 47,
    transform: "translate(382.162 221.234) rotate(180)",
    fill: "url(#linear-gradient-12)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_276",
    "data-name": "\\uC0AC\\uAC01\\uD615 276",
    width: 11,
    height: 120,
    transform: "translate(382.162 339.234) rotate(180)",
    fill: "url(#linear-gradient-13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2467",
    "data-name": "\\uD328\\uC2A4 2467",
    d: "M978.87,10138.019v-11h-35v40h-100v11h100v35h35v-11h-24v-64Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "url(#linear-gradient-14)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1234",
    "data-name": "\\uADF8\\uB8F9 1234",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1233",
    "data-name": "\\uADF8\\uB8F9 1233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1225",
    "data-name": "\\uADF8\\uB8F9 1225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1223",
    "data-name": "\\uADF8\\uB8F9 1223"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_277",
    "data-name": "\\uC0AC\\uAC01\\uD615 277",
    width: 3.913,
    height: 14.36,
    transform: "translate(785.261 10196.814)",
    fill: "#8d8e8e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1224",
    "data-name": "\\uADF8\\uB8F9 1224"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_278",
    "data-name": "\\uC0AC\\uAC01\\uD615 278",
    width: 3.916,
    height: 14.36,
    transform: "translate(847.901 10196.814)",
    fill: "#8d8e8e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1226",
    "data-name": "\\uADF8\\uB8F9 1226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2468",
    "data-name": "\\uD328\\uC2A4 2468",
    d: "M847.231,10196.815c0-3.084-12.847-5.584-28.694-5.584s-28.689,2.5-28.689,5.584,12.846,5.583,28.689,5.583S847.231,10199.9,847.231,10196.815Z",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1227",
    "data-name": "\\uADF8\\uB8F9 1227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2469",
    "data-name": "\\uD328\\uC2A4 2469",
    d: "M852.991,10099.723c0-3.7-15.427-6.7-34.454-6.7s-34.45,3-34.45,6.7,15.424,6.7,34.45,6.7S852.991,10103.426,852.991,10099.723Z",
    fill: "#cdcdcd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1232",
    "data-name": "\\uADF8\\uB8F9 1232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1228",
    "data-name": "\\uADF8\\uB8F9 1228"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_279",
    "data-name": "\\uC0AC\\uAC01\\uD615 279",
    width: 68.904,
    height: 97.107,
    transform: "translate(784.087 10099.723)",
    fill: "#9b9c9c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1229",
    "data-name": "\\uADF8\\uB8F9 1229"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_280",
    "data-name": "\\uC0AC\\uAC01\\uD615 280",
    width: 68.904,
    height: 95.679,
    transform: "translate(784.087 10101.15)",
    fill: "#d5d5d5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1230",
    "data-name": "\\uADF8\\uB8F9 1230"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_281",
    "data-name": "\\uC0AC\\uAC01\\uD615 281",
    width: 3.482,
    height: 95.672,
    transform: "translate(785.827 10101.143)",
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1231",
    "data-name": "\\uADF8\\uB8F9 1231"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_282",
    "data-name": "\\uC0AC\\uAC01\\uD615 282",
    width: 1.743,
    height: 95.672,
    transform: "translate(791.38 10101.143)",
    fill: "#eaeaea"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2470",
    "data-name": "\\uD328\\uC2A4 2470",
    d: "M851.726,10210.754h-3.734l-2.082,3.778h7.9Z",
    fill: "#8d8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2471",
    "data-name": "\\uD328\\uC2A4 2471",
    d: "M789.082,10210.754h-3.733l-2.082,3.778h7.9Z",
    fill: "#8d8e8e"
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "\\uC0B0\\uC18C_O2_",
    "data-name": "\\uC0B0\\uC18C(O2)",
    transform: "translate(1.889 132)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC0B0\uC18C(O2)"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC5F0\\uB8CC\\uC7A5\\uCE58",
    transform: "translate(346.89 15)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC5F0\uB8CC\uC7A5\uCE58"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC804\\uAE30",
    transform: "translate(781.89 152.818)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC804\uAE30"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC628\\uC218",
    transform: "translate(802.89 273.818)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC628\uC218"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "\\uB09C\\uBC29",
    transform: "translate(802.89 352.818)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uB09C\uBC29"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC5F0\\uB8CC",
    transform: "translate(21.889 381.931)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC5F0\uB8CC"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC5F4\\uAD50\\uD658\\uC7A5\\uCE58",
    transform: "translate(342.89 381.931)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC5F4\uAD50\uD658\uC7A5\uCE58"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "\\uCD95\\uC5F4\\uC870",
    transform: "translate(516.89 381.999)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uCD95\uC5F4\uC870"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC5F0\\uB8CC\\uCC98\\uB9AC\\uC7A5\\uCE58_\\uAC1C\\uC9C8\\uAE30_",
    "data-name": "\\uC5F0\\uB8CC\\uCC98\\uB9AC\\uC7A5\\uCE58 (\\uAC1C\\uC9C8\\uAE30)",
    transform: "translate(197.89 371.775)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -47.94,
    y: 0
  }, "\uC5F0\uB8CC\uCC98\uB9AC\uC7A5\uCE58"), /*#__PURE__*/React.createElement("tspan", {
    x: -30.141,
    y: 20.312
  }, "(\uAC1C\uC9C8\uAE30)"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1245",
    "data-name": "\\uADF8\\uB8F9 1245",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_283",
    "data-name": "\\uC0AC\\uAC01\\uD615 283",
    width: 62.269,
    height: 88.656,
    transform: "translate(843.37 9903.019)",
    fill: "#dddbd6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_284",
    "data-name": "\\uC0AC\\uAC01\\uD615 284",
    width: 62.269,
    height: 2.551,
    transform: "translate(843.37 9903.019)",
    fill: "#fefcf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_285",
    "data-name": "\\uC0AC\\uAC01\\uD615 285",
    width: 23.652,
    height: 18.817,
    transform: "translate(863.135 9917.528)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_286",
    "data-name": "\\uC0AC\\uAC01\\uD615 286",
    width: 23.652,
    height: 0.36,
    transform: "translate(863.135 9917.528)",
    fill: "#bebcb7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_287",
    "data-name": "\\uC0AC\\uAC01\\uD615 287",
    width: 23.652,
    height: 0.36,
    transform: "translate(863.135 9935.985)",
    fill: "#fefcf7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_288",
    "data-name": "\\uC0AC\\uAC01\\uD615 288",
    width: 14.757,
    height: 7.441,
    transform: "translate(867.735 9920.892)",
    fill: "#58625b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_289",
    "data-name": "\\uC0AC\\uAC01\\uD615 289",
    width: 14.318,
    height: 7.002,
    transform: "translate(867.955 9921.111)",
    fill: "#7e8881"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_290",
    "data-name": "\\uC0AC\\uAC01\\uD615 290",
    width: 62.269,
    height: 10.344,
    transform: "translate(843.37 9991.675)",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_291",
    "data-name": "\\uC0AC\\uAC01\\uD615 291",
    width: 62.269,
    height: 2.707,
    transform: "translate(843.37 9991.675)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_292",
    "data-name": "\\uC0AC\\uAC01\\uD615 292",
    width: 1.919,
    height: 61.335,
    transform: "translate(905.639 9911.603)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_293",
    "data-name": "\\uC0AC\\uAC01\\uD615 293",
    width: 1.919,
    height: 61.335,
    transform: "translate(841.45 9911.603)",
    fill: "#414e5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1236",
    "data-name": "\\uADF8\\uB8F9 1236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1235",
    "data-name": "\\uADF8\\uB8F9 1235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2472",
    "data-name": "\\uD328\\uC2A4 2472",
    d: "M872.028,9923.332h-.961l-.114.114.114.113h.961l.114-.113Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2473",
    "data-name": "\\uD328\\uC2A4 2473",
    d: "M872.028,9922.066h-.961l-.114.113.114.114h.961l.114-.114Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2474",
    "data-name": "\\uD328\\uC2A4 2474",
    d: "M872.028,9924.6h-.961l-.114.114.114.112h.961l.114-.112Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2475",
    "data-name": "\\uD328\\uC2A4 2475",
    d: "M870.914,9922.219l-.113.113v.962l.113.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2476",
    "data-name": "\\uD328\\uC2A4 2476",
    d: "M872.18,9922.219l-.114.113v.962l.114.113.113-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2477",
    "data-name": "\\uD328\\uC2A4 2477",
    d: "M870.914,9923.484l-.113.113v.962l.113.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2478",
    "data-name": "\\uD328\\uC2A4 2478",
    d: "M872.18,9923.484l-.114.113v.962l.114.113.113-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2479",
    "data-name": "\\uD328\\uC2A4 2479",
    d: "M870.2,9923.332h-.961l-.113.114.113.113h.961l.114-.113Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2480",
    "data-name": "\\uD328\\uC2A4 2480",
    d: "M870.2,9922.066h-.961l-.113.113.113.114h.961l.114-.114Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2481",
    "data-name": "\\uD328\\uC2A4 2481",
    d: "M870.2,9924.6h-.961l-.113.114.113.112h.961l.114-.112Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2482",
    "data-name": "\\uD328\\uC2A4 2482",
    d: "M869.087,9922.219l-.114.113v.962l.114.113.113-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2483",
    "data-name": "\\uD328\\uC2A4 2483",
    d: "M870.352,9922.219l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2484",
    "data-name": "\\uD328\\uC2A4 2484",
    d: "M869.087,9923.484l-.114.113v.962l.114.113.113-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2485",
    "data-name": "\\uD328\\uC2A4 2485",
    d: "M870.352,9923.484l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2486",
    "data-name": "\\uD328\\uC2A4 2486",
    d: "M876.321,9923.332h-.961l-.114.114.114.113h.961l.114-.113Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2487",
    "data-name": "\\uD328\\uC2A4 2487",
    d: "M876.321,9922.066h-.961l-.114.113.114.114h.961l.114-.114Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2488",
    "data-name": "\\uD328\\uC2A4 2488",
    d: "M876.321,9924.6h-.961l-.114.114.114.112h.961l.114-.112Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2489",
    "data-name": "\\uD328\\uC2A4 2489",
    d: "M875.208,9922.219l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2490",
    "data-name": "\\uD328\\uC2A4 2490",
    d: "M876.474,9922.219l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2491",
    "data-name": "\\uD328\\uC2A4 2491",
    d: "M875.208,9923.484l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2492",
    "data-name": "\\uD328\\uC2A4 2492",
    d: "M876.474,9923.484l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2493",
    "data-name": "\\uD328\\uC2A4 2493",
    d: "M874.493,9923.332h-.961l-.114.114.114.113h.961l.114-.113Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2494",
    "data-name": "\\uD328\\uC2A4 2494",
    d: "M874.493,9922.066h-.961l-.114.113.114.114h.961l.114-.114Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2495",
    "data-name": "\\uD328\\uC2A4 2495",
    d: "M874.493,9924.6h-.961l-.114.114.114.112h.961l.114-.112Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2496",
    "data-name": "\\uD328\\uC2A4 2496",
    d: "M873.38,9922.219l-.114.113v.962l.114.113.113-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2497",
    "data-name": "\\uD328\\uC2A4 2497",
    d: "M874.645,9922.219l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2498",
    "data-name": "\\uD328\\uC2A4 2498",
    d: "M873.38,9923.484l-.114.113v.962l.114.113.113-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2499",
    "data-name": "\\uD328\\uC2A4 2499",
    d: "M874.645,9923.484l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_294",
    "data-name": "\\uC0AC\\uAC01\\uD615 294",
    width: 0.226,
    height: 0.226,
    transform: "translate(872.672 9924.598)",
    fill: "#414e52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2500",
    "data-name": "\\uD328\\uC2A4 2500",
    d: "M880.613,9923.332h-.961l-.114.114.114.113h.961l.114-.113Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2501",
    "data-name": "\\uD328\\uC2A4 2501",
    d: "M880.613,9922.066h-.961l-.114.113.114.114h.961l.114-.114Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2502",
    "data-name": "\\uD328\\uC2A4 2502",
    d: "M880.613,9924.6h-.961l-.114.114.114.112h.961l.114-.112Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2503",
    "data-name": "\\uD328\\uC2A4 2503",
    d: "M879.5,9922.219l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2504",
    "data-name": "\\uD328\\uC2A4 2504",
    d: "M880.765,9922.219l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2505",
    "data-name": "\\uD328\\uC2A4 2505",
    d: "M879.5,9923.484l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2506",
    "data-name": "\\uD328\\uC2A4 2506",
    d: "M880.765,9923.484l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2507",
    "data-name": "\\uD328\\uC2A4 2507",
    d: "M878.785,9923.332h-.962l-.113.114.113.113h.962l.113-.113Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2508",
    "data-name": "\\uD328\\uC2A4 2508",
    d: "M878.785,9922.066h-.962l-.113.113.113.114h.962l.113-.114Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2509",
    "data-name": "\\uD328\\uC2A4 2509",
    d: "M878.785,9924.6h-.962l-.113.114.113.112h.962l.113-.112Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2510",
    "data-name": "\\uD328\\uC2A4 2510",
    d: "M877.671,9922.219l-.114.113v.962l.114.113.113-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2511",
    "data-name": "\\uD328\\uC2A4 2511",
    d: "M878.936,9922.219l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2512",
    "data-name": "\\uD328\\uC2A4 2512",
    d: "M877.671,9923.484l-.114.113v.962l.114.113.113-.113v-.962Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2513",
    "data-name": "\\uD328\\uC2A4 2513",
    d: "M878.936,9923.484l-.114.113v.962l.114.113.114-.113v-.962Z",
    fill: "#414e52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1237",
    "data-name": "\\uADF8\\uB8F9 1237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2514",
    "data-name": "\\uD328\\uC2A4 2514",
    d: "M869.144,9933.382a1.458,1.458,0,1,1,1.457-1.457A1.459,1.459,0,0,1,869.144,9933.382Zm0-2.817a1.36,1.36,0,1,0,1.361,1.36A1.361,1.361,0,0,0,869.144,9930.564Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1238",
    "data-name": "\\uADF8\\uB8F9 1238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2515",
    "data-name": "\\uD328\\uC2A4 2515",
    d: "M873.134,9933.382a1.458,1.458,0,1,1,1.457-1.457A1.458,1.458,0,0,1,873.134,9933.382Zm0-2.817a1.36,1.36,0,1,0,1.36,1.36A1.361,1.361,0,0,0,873.134,9930.564Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1239",
    "data-name": "\\uADF8\\uB8F9 1239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2516",
    "data-name": "\\uD328\\uC2A4 2516",
    d: "M877.124,9933.382a1.458,1.458,0,1,1,1.457-1.457A1.459,1.459,0,0,1,877.124,9933.382Zm0-2.817a1.36,1.36,0,1,0,1.36,1.36A1.362,1.362,0,0,0,877.124,9930.564Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1240",
    "data-name": "\\uADF8\\uB8F9 1240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2517",
    "data-name": "\\uD328\\uC2A4 2517",
    d: "M881.113,9933.382a1.458,1.458,0,1,1,1.458-1.457A1.459,1.459,0,0,1,881.113,9933.382Zm0-2.817a1.36,1.36,0,1,0,1.361,1.36A1.362,1.362,0,0,0,881.113,9930.564Z",
    fill: "#d4dbdf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1241",
    "data-name": "\\uADF8\\uB8F9 1241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2518",
    "data-name": "\\uD328\\uC2A4 2518",
    d: "M866.4,9922.747a.681.681,0,1,1-.681-.681A.681.681,0,0,1,866.4,9922.747Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2519",
    "data-name": "\\uD328\\uC2A4 2519",
    d: "M866.3,9922.747a.584.584,0,1,1-.584-.584A.584.584,0,0,1,866.3,9922.747Z",
    fill: "red",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2520",
    "data-name": "\\uD328\\uC2A4 2520",
    d: "M866.158,9922.747a.438.438,0,1,1-.438-.438A.437.437,0,0,1,866.158,9922.747Z",
    fill: "red",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2521",
    "data-name": "\\uD328\\uC2A4 2521",
    d: "M866.041,9922.747a.321.321,0,1,1-.321-.32A.322.322,0,0,1,866.041,9922.747Z",
    fill: "red"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1242",
    "data-name": "\\uADF8\\uB8F9 1242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2522",
    "data-name": "\\uD328\\uC2A4 2522",
    d: "M866.4,9926.105a.681.681,0,1,1-.681-.682A.681.681,0,0,1,866.4,9926.105Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2523",
    "data-name": "\\uD328\\uC2A4 2523",
    d: "M866.3,9926.105a.584.584,0,1,1-.584-.584A.585.585,0,0,1,866.3,9926.105Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2524",
    "data-name": "\\uD328\\uC2A4 2524",
    d: "M866.158,9926.105a.438.438,0,1,1-.438-.438A.438.438,0,0,1,866.158,9926.105Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2525",
    "data-name": "\\uD328\\uC2A4 2525",
    d: "M866.041,9926.105a.321.321,0,1,1-.321-.32A.321.321,0,0,1,866.041,9926.105Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1243",
    "data-name": "\\uADF8\\uB8F9 1243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2526",
    "data-name": "\\uD328\\uC2A4 2526",
    d: "M885.029,9922.747a.681.681,0,1,1-.681-.681A.681.681,0,0,1,885.029,9922.747Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2527",
    "data-name": "\\uD328\\uC2A4 2527",
    d: "M884.933,9922.747a.585.585,0,1,1-.585-.584A.584.584,0,0,1,884.933,9922.747Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2528",
    "data-name": "\\uD328\\uC2A4 2528",
    d: "M884.786,9922.747a.438.438,0,1,1-.438-.438A.437.437,0,0,1,884.786,9922.747Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2529",
    "data-name": "\\uD328\\uC2A4 2529",
    d: "M884.669,9922.747a.32.32,0,1,1-.321-.32A.322.322,0,0,1,884.669,9922.747Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1244",
    "data-name": "\\uADF8\\uB8F9 1244"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2530",
    "data-name": "\\uD328\\uC2A4 2530",
    d: "M885.029,9926.105a.681.681,0,1,1-.681-.682A.681.681,0,0,1,885.029,9926.105Z",
    fill: "#29333f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2531",
    "data-name": "\\uD328\\uC2A4 2531",
    d: "M884.933,9926.105a.585.585,0,1,1-.585-.584A.585.585,0,0,1,884.933,9926.105Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2532",
    "data-name": "\\uD328\\uC2A4 2532",
    d: "M884.786,9926.105a.438.438,0,1,1-.438-.438A.438.438,0,0,1,884.786,9926.105Z",
    fill: "lime",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2533",
    "data-name": "\\uD328\\uC2A4 2533",
    d: "M884.669,9926.105a.32.32,0,1,1-.321-.32A.321.321,0,0,1,884.669,9926.105Z",
    fill: "lime"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2534",
    "data-name": "\\uD328\\uC2A4 2534",
    d: "M869.935,9926.968a.424.424,0,1,1-.425-.425A.425.425,0,0,1,869.935,9926.968Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2535",
    "data-name": "\\uD328\\uC2A4 2535",
    d: "M871.377,9926.968a.424.424,0,1,1-.424-.425A.424.424,0,0,1,871.377,9926.968Z",
    fill: "#414e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2536",
    "data-name": "\\uD328\\uC2A4 2536",
    d: "M880.98,9926.968a.424.424,0,1,1-.423-.425A.423.423,0,0,1,880.98,9926.968Z",
    fill: "#414e52"
  }))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "\\uACC4\\uCE21\\uC810",
    transform: "translate(501.894 53.409)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uACC4\uCE21\uC810"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_22",
    "data-name": "\\uD0C0\\uC6D0 22",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(511.759 78.234)",
    fill: "url(#radial-gradient)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1246",
    "data-name": "\\uADF8\\uB8F9 1246",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2537",
    "data-name": "\\uD328\\uC2A4 2537",
    d: "M799.711,9935.8q-1.125-1.126-2.253-2.252a.623.623,0,0,1-.22-.713c.116-.3.368-.325.633-.325.536,0,1.073-.014,1.608.01.27.012.3-.081.271-.318-.279-2.293-.547-4.588-.819-6.882-.043-.364-.088-.729-.124-1.094a.52.52,0,0,1,.56-.637q3.1-.007,6.192,0c.421,0,.618.248.567.685q-.456,3.914-.918,7.829a.992.992,0,0,1-.02.146c-.05.2.009.274.232.269.565-.018,1.131-.008,1.7-.007.25,0,.471.043.58.315a.577.577,0,0,1-.168.672q-2.3,2.307-4.61,4.609a.577.577,0,0,1-.911-.015Q800.856,9936.956,799.711,9935.8Z",
    fill: "#fe3c38"
  }))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "\\uACC4\\uCE21\\uC810-2",
    "data-name": "\\uACC4\\uCE21\\uC810",
    transform: "translate(439.295 272.409)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uACC4\uCE21\uC810"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_23",
    "data-name": "\\uD0C0\\uC6D0 23",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(449.162 297.234)",
    fill: "url(#radial-gradient)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1247",
    "data-name": "\\uADF8\\uB8F9 1247",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2538",
    "data-name": "\\uD328\\uC2A4 2538",
    d: "M737.112,10154.8q-1.125-1.126-2.253-2.252a.623.623,0,0,1-.22-.713c.116-.3.368-.325.633-.325.536,0,1.073-.014,1.608.01.27.012.3-.081.271-.318-.279-2.293-.547-4.588-.819-6.882-.043-.364-.088-.729-.124-1.094a.52.52,0,0,1,.56-.637q3.1-.007,6.192,0c.421,0,.618.248.568.685q-.457,3.914-.919,7.829a.992.992,0,0,1-.02.146c-.05.2.009.274.232.269.565-.018,1.131-.008,1.7-.007.25,0,.471.043.58.315a.578.578,0,0,1-.167.672q-2.3,2.307-4.611,4.609a.577.577,0,0,1-.911-.015Q738.257,10155.956,737.112,10154.8Z",
    fill: "#fe3c38"
  }))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "\\uACC4\\uCE21\\uC810-3",
    "data-name": "\\uACC4\\uCE21\\uC810",
    transform: "translate(596.295 272.409)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uACC4\uCE21\uC810"))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_24",
    "data-name": "\\uD0C0\\uC6D0 24",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(606.162 297.234)",
    fill: "url(#radial-gradient)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1248",
    "data-name": "\\uADF8\\uB8F9 1248",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2539",
    "data-name": "\\uD328\\uC2A4 2539",
    d: "M894.112,10154.8q-1.125-1.126-2.253-2.252a.623.623,0,0,1-.22-.713c.116-.3.368-.325.633-.325.536,0,1.073-.014,1.608.01.27.012.3-.081.271-.318-.279-2.293-.547-4.588-.819-6.882-.043-.364-.088-.729-.124-1.094a.52.52,0,0,1,.56-.637q3.1-.007,6.192,0c.421,0,.618.248.568.685q-.457,3.914-.919,7.829a.992.992,0,0,1-.02.146c-.05.2.009.274.232.269.565-.018,1.131-.008,1.7-.007.25,0,.471.043.58.315a.578.578,0,0,1-.167.672q-2.3,2.307-4.611,4.609a.577.577,0,0,1-.911-.015Q895.257,10155.956,894.112,10154.8Z",
    fill: "#fe3c38"
  }))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    id: "\\uACC4\\uCE21\\uC810-4",
    "data-name": "\\uACC4\\uCE21\\uC810",
    transform: "translate(648.295 53.409)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uACC4\uCE21\uC810"))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_25",
    "data-name": "\\uD0C0\\uC6D0 25",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(658.162 78.234)",
    fill: "url(#radial-gradient)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1249",
    "data-name": "\\uADF8\\uB8F9 1249",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2540",
    "data-name": "\\uD328\\uC2A4 2540",
    d: "M946.112,9935.8q-1.125-1.126-2.253-2.252a.623.623,0,0,1-.22-.713c.116-.3.368-.325.633-.325.536,0,1.073-.014,1.608.01.27.012.3-.081.271-.318-.279-2.293-.547-4.588-.819-6.882-.043-.364-.088-.729-.124-1.094a.52.52,0,0,1,.56-.637q3.1-.007,6.192,0c.421,0,.618.248.568.685q-.457,3.914-.919,7.829a.992.992,0,0,1-.02.146c-.05.2.009.274.232.269.565-.018,1.131-.008,1.7-.007.25,0,.471.043.58.315a.578.578,0,0,1-.167.672q-2.3,2.307-4.611,4.609a.577.577,0,0,1-.911-.015Q947.257,9936.956,946.112,9935.8Z",
    fill: "#fe3c38"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1250",
    "data-name": "\\uADF8\\uB8F9 1250",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2541",
    "data-name": "\\uD328\\uC2A4 2541",
    d: "M317.471,9902.652a20.6,20.6,0,0,1,11.173,10.93,21.081,21.081,0,0,1,1.752,8.228c.082,8.085.044,16.171.053,24.257a10.647,10.647,0,0,1-3.791,1.8c-8,.476-16.008.188-24.013.165-.2-4.275.33-8.568-.333-12.831a10.729,10.729,0,0,0,4.488-.006,9.751,9.751,0,0,0,7.335-6.633,9.548,9.548,0,0,0-2.125-9.768c-2.264-2.6-5.163-3.405-8.458-3.25.064-.3.1-.618.2-.914.992-3.18,3.146-5.618,5.2-8.119l1.872-.105A9.33,9.33,0,0,0,317.471,9902.652Zm3.213,32.852v-.065a29.157,29.157,0,0,0,3.148-.029,1.228,1.228,0,0,0,1.223-1.375,1.324,1.324,0,0,0-1.428-1.355c-.63-.023-1.264-.032-1.894,0-1.126.055-1.148-.335-.548-1.143a23.835,23.835,0,0,0,3.032-4.774,4.282,4.282,0,0,0-2.452-5.772,4.485,4.485,0,0,0-5.755,2.961,1.239,1.239,0,0,0,.613,1.606,1.224,1.224,0,0,0,1.78-.43c.159-.271.274-.569.438-.838a1.591,1.591,0,0,1,2.2-.636,1.489,1.489,0,0,1,.64,2.156,9.732,9.732,0,0,1-.765,1.374c-1.271,1.8-2.547,3.593-3.866,5.354a1.958,1.958,0,0,0-.361,2.192c.385.719,1.183.787,1.944.778C319.316,9935.5,320,9935.5,320.684,9935.5Z",
    fill: "#b1e3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2542",
    "data-name": "\\uD328\\uC2A4 2542",
    d: "M302.645,9948.035c8.005.022,16.012.311,24.013-.165a2.272,2.272,0,0,0,.707.265c5.228.044,10.239-4.052,10.321-9.533.073-4.887-.045-9.775.04-14.661.05-2.888.391-5.762,2.01-8.284,1.8-2.8,3.983-5.119,7.471-5.726a22.256,22.256,0,0,0,.276,6.016c-4.338,1.365-5.693,3.229-5.7,7.832,0,4.105-.077,8.214.016,12.318.194,8.564-3.549,14.575-11.421,17.993a28.333,28.333,0,0,1-8.7.994c-6.349-.044-12.7.014-19.049.03l-7.909-.1c-.214-.848-1.036-.631-1.561-.787a18.77,18.77,0,0,1-13.317-18.169c.163-10.14-.035-20.285.065-30.428.07-7.192,3.666-12.349,9.76-15.933,1.878-1.1,4.037-1.379,6.009-2.193l11.057.006q0,.612.008,1.225a10.353,10.353,0,0,0-5.543,5.721c-2-.01-4-.06-5.992-.024a11.7,11.7,0,0,0-11.5,11.465c-.089,10.2-.1,20.4.012,30.595a10.962,10.962,0,0,0,5.655,9.746,8.178,8.178,0,0,0,3.871,1.578C296.358,9948.376,299.506,9948.087,302.645,9948.035Z",
    fill: "#417093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2543",
    "data-name": "\\uD328\\uC2A4 2543",
    d: "M302.628,9955.114c6.35-.017,12.7-.074,19.05-.03a28.333,28.333,0,0,0,8.7-.994c.145,2.87.156,5.7-2.214,7.867a5.8,5.8,0,0,1-3.972,1.654c-5.622.016-11.244-.013-16.866-.023-1.8-.943-3.581-1.867-4.374-3.979C302.395,9958.112,302.76,9956.608,302.628,9955.114Z",
    fill: "#b1e3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2544",
    "data-name": "\\uD328\\uC2A4 2544",
    d: "M295.676,9887.5c-1.972.814-4.131,1.089-6.009,2.193-6.094,3.584-9.69,8.74-9.76,15.933-.1,10.143.1,20.288-.065,30.428a18.77,18.77,0,0,0,13.317,18.169c.525.156,1.347-.061,1.561.787a23.109,23.109,0,0,1-5.3-.9c-5.8-2.345-9.938-6.29-11.869-12.353a16.223,16.223,0,0,1-.824-4.938c0-10.407-.036-20.815.01-31.223C276.777,9895.6,285.648,9887.16,295.676,9887.5Z",
    fill: "#385f7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2545",
    "data-name": "\\uD328\\uC2A4 2545",
    d: "M347.779,9908.633c1.207-5.185,6.452-9.073,12.331-9.138q-.016,8.685-.032,17.37a12.85,12.85,0,0,1-8.975-3.739A30.9,30.9,0,0,1,347.779,9908.633Z",
    fill: "#eeebee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2546",
    "data-name": "\\uD328\\uC2A4 2546",
    d: "M317.471,9902.652a9.33,9.33,0,0,1-6.651,3.757,10.824,10.824,0,0,1-5.282-3.163,9.285,9.285,0,0,1-.56-11.054c1.36-1.914,3.3-2.8,5.25-3.772a8.815,8.815,0,0,1,2.829.328,9.555,9.555,0,0,1,5.863,7.282C319.363,9898.467,318.549,9900.575,317.471,9902.652Zm-8.8-9.4c-2.048.825-3.229,2.4-3.163,4.217.071,1.974,1.286,3.443,3.458,4.184a4.366,4.366,0,0,0,4.363-7.013A4.075,4.075,0,0,0,308.672,9893.249Z",
    fill: "#fddf7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2547",
    "data-name": "\\uD328\\uC2A4 2547",
    d: "M347.207,9909.931c-3.488.606-5.674,2.923-7.471,5.726-1.619,2.522-1.96,5.4-2.01,8.284-.085,4.886.033,9.774-.04,14.661-.082,5.481-5.093,9.577-10.321,9.533a2.272,2.272,0,0,1-.707-.265,10.647,10.647,0,0,0,3.791-1.8c3.1-2.1,4.319-5.154,4.353-8.758.047-5.2-.06-10.4.064-15.6a13.433,13.433,0,0,1,12.616-12.719C347.472,9909.33,347.506,9909.679,347.207,9909.931Z",
    fill: "#385f7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2548",
    "data-name": "\\uD328\\uC2A4 2548",
    d: "M360.078,9916.865q.015-8.685.032-17.37,1.431-2.607,3.421-2.155c1.536.351,2.289,1.531,2.285,3.641q-.014,8.265-.044,16.528a1.546,1.546,0,0,0-.93.486c-1.413,1.094-2.321,1.094-3.737,0a1.528,1.528,0,0,0-.932-.482Z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2549",
    "data-name": "\\uD328\\uC2A4 2549",
    d: "M289.416,9954.116a23.109,23.109,0,0,0,5.3.9l7.909.1c.131,1.494-.234,3,.328,4.494.793,2.112,2.57,3.036,4.374,3.979-3.893.01-7.786.064-11.678.02-3.532-.04-6.1-2.938-6.254-6.968C289.366,9955.8,289.409,9954.957,289.416,9954.116Z",
    fill: "#91d7f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2550",
    "data-name": "\\uD328\\uC2A4 2550",
    d: "M360.078,9916.865l.094.646q-.042,3.962-.083,7.924c-6.438-.193-10.488-3.559-12.606-9.489a22.256,22.256,0,0,1-.276-6.016c.3-.252.265-.6.275-.937l.3-.36a30.9,30.9,0,0,0,3.324,4.493A12.85,12.85,0,0,0,360.078,9916.865Z",
    fill: "#dad9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2551",
    "data-name": "\\uD328\\uC2A4 2551",
    d: "M313.057,9888.748a8.815,8.815,0,0,0-2.829-.328l-.331-.137c0-1.208-.074-2.422.02-3.622.1-1.229-.3-1.689-1.575-1.62a2.977,2.977,0,0,1-2.87-2.06c-.582-1.254,0-2.2.878-3.064a9.587,9.587,0,0,0,.7-.844c3.194,0,6.39-.026,9.584,0,2.126.02,3.42,1.242,3.376,3.092-.043,1.78-1.321,2.885-3.361,2.9-.523,0-1.047,0-1.571,0-2.016,0-2.016,0-2.018,2.063Q313.056,9886.941,313.057,9888.748Z",
    fill: "#eeebee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2552",
    "data-name": "\\uD328\\uC2A4 2552",
    d: "M307.046,9877.073a9.587,9.587,0,0,1-.7.844c-.881.86-1.46,1.811-.878,3.064a2.977,2.977,0,0,0,2.87,2.06c1.275-.069,1.671.392,1.575,1.62-.094,1.2-.02,2.414-.02,3.622l-3.156.45-.008-1.225c-.028-1.356.414-3.012-.208-3.992-.72-1.135-2.5-.314-3.817-.432a3.011,3.011,0,0,1-2.914-3.065,2.912,2.912,0,0,1,2.857-2.939C304.115,9877.034,305.581,9877.072,307.046,9877.073Z",
    fill: "#dad9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2553",
    "data-name": "\\uD328\\uC2A4 2553",
    d: "M360.089,9925.436q.042-3.961.083-7.924a1.528,1.528,0,0,1,.933.482c1.416,1.095,2.324,1.095,3.737,0a1.546,1.546,0,0,1,.93-.486c.016,2.158.038,4.316.044,6.475.006,2.032-.723,3.233-2.145,3.573C362.145,9927.922,361.062,9927.281,360.089,9925.436Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2554",
    "data-name": "\\uD328\\uC2A4 2554",
    d: "M302.645,9948.035c-3.139.052-6.287.341-9.4-.222a8.178,8.178,0,0,1-3.871-1.578c.008-7.769-.011-15.537.045-23.3a25.771,25.771,0,0,1,.477-5.14,20.424,20.424,0,0,1,12.451-15.146,10.024,10.024,0,0,0,6.606,3.87c-2.054,2.5-4.208,4.939-5.2,8.119-.092.3-.132.609-.2.915-.1.028-.191.052-.288.073a9.964,9.964,0,0,0-8.53,8.743c-.366,5.337,2.534,9.465,7.594,10.808l-.016.031C302.975,9939.467,302.446,9943.76,302.645,9948.035Z",
    fill: "#90d7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2555",
    "data-name": "\\uD328\\uC2A4 2555",
    d: "M303.264,9915.622c.1-.021.193-.045.288-.073,3.295-.156,6.194.653,8.458,3.249a9.548,9.548,0,0,1,2.125,9.768,9.751,9.751,0,0,1-7.335,6.633,10.729,10.729,0,0,1-4.488.006l.016-.031q-.006-1.389-.011-2.779a7.381,7.381,0,0,0,9.577-7.564c-.206-3.986-5.3-7.854-8.942-6.4A10.775,10.775,0,0,1,303.264,9915.622Z",
    fill: "#ecebee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2556",
    "data-name": "\\uD328\\uC2A4 2556",
    d: "M320.684,9935.5c-.684,0-1.368-.006-2.052,0-.761.009-1.559-.06-1.944-.778a1.958,1.958,0,0,1,.361-2.192c1.319-1.762,2.6-3.557,3.866-5.354a9.732,9.732,0,0,0,.765-1.374,1.489,1.489,0,0,0-.64-2.156,1.591,1.591,0,0,0-2.2.636c-.164.269-.279.566-.438.838a1.224,1.224,0,0,1-1.78.43,1.239,1.239,0,0,1-.613-1.606,4.485,4.485,0,0,1,5.755-2.961,4.282,4.282,0,0,1,2.452,5.772,23.835,23.835,0,0,1-3.032,4.774c-.6.808-.578,1.2.548,1.143.63-.029,1.264-.021,1.894,0a1.324,1.324,0,0,1,1.428,1.355,1.228,1.228,0,0,1-1.223,1.375,29.157,29.157,0,0,1-3.148.029Z",
    fill: "#ecebee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2557",
    "data-name": "\\uD328\\uC2A4 2557",
    d: "M308.948,9906.515a9.136,9.136,0,0,1-7.75-12.061,10.353,10.353,0,0,1,5.543-5.721l3.156-.45.331.137c-1.952.972-3.89,1.858-5.25,3.772a9.285,9.285,0,0,0,.56,11.054,10.824,10.824,0,0,0,5.282,3.163Z",
    fill: "#fccf66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2558",
    "data-name": "\\uD328\\uC2A4 2558",
    d: "M308.967,9901.649c-2.172-.74-3.387-2.21-3.458-4.184-.066-1.815,1.115-3.392,3.163-4.217,2.3,1.127,3.118,2.578,2.8,4.983C311.255,9899.823,310.087,9900.72,308.967,9901.649Z",
    fill: "#b1e3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2559",
    "data-name": "\\uD328\\uC2A4 2559",
    d: "M308.967,9901.649c1.12-.93,2.288-1.826,2.5-3.417.322-2.405-.495-3.856-2.8-4.983a4.075,4.075,0,0,1,4.658,1.388,4.366,4.366,0,0,1-4.363,7.013Z",
    fill: "#90d7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2560",
    "data-name": "\\uD328\\uC2A4 2560",
    d: "M303.264,9915.622a10.775,10.775,0,0,0-.312,2.812l-.328.293a6.45,6.45,0,0,0-5.066,6.322c-.047,3.61,1.789,6.341,4.746,7.06a1.512,1.512,0,0,0,.013.285q.006,1.392.011,2.779c-5.06-1.343-7.96-5.471-7.594-10.808A9.964,9.964,0,0,1,303.264,9915.622Z",
    fill: "#dad9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2561",
    "data-name": "\\uD328\\uC2A4 2561",
    d: "M302.624,9918.727l.328-.293c3.645-1.458,8.736,2.409,8.942,6.4a7.381,7.381,0,0,1-9.577,7.564,1.519,1.519,0,0,1-.013-.286C302.379,9927.646,302.148,9923.178,302.624,9918.727Z",
    fill: "#b1e3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2562",
    "data-name": "\\uD328\\uC2A4 2562",
    d: "M302.624,9918.727c-.476,4.451-.245,8.92-.32,13.381-2.957-.718-4.793-3.448-4.746-7.059A6.45,6.45,0,0,1,302.624,9918.727Z",
    fill: "#91d7f8"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1251",
    "data-name": "\\uADF8\\uB8F9 1251",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2563",
    "data-name": "\\uD328\\uC2A4 2563",
    d: "M303.242,10140.777a55.34,55.34,0,0,0,4.767-4.308,9.766,9.766,0,0,1,7.13-2.807c1.577.02,3.154.029,4.731.044v13.33c-2.636.017-5.272.039-7.908.048a1.958,1.958,0,0,0-1.48.39q-3.723,3.546-7.446,7.094a1.284,1.284,0,0,0-.288,1.459,1.212,1.212,0,0,0,1.154.732,10.659,10.659,0,0,0,1.186.024l14.765.052q.01,11.6.023,23.2a60.2,60.2,0,0,1-4.618-4.476c-2.88-2.836-5.713-5.719-8.588-8.561a2.169,2.169,0,0,0-3.623.41,2.29,2.29,0,0,0,.722,2.82c4.047,4.03,8.062,8.095,12.137,12.1.762.749.837,1.159.029,1.951-4.112,4.026-8.168,8.111-12.221,12.2-1.166,1.176-1.218,2.394-.25,3.367.891.9,2.258.787,3.376-.3,1.226-1.2,2.421-2.426,3.64-3.63q4.682-4.625,9.374-9.238.008,10.668.015,21.334c-8.128.011-16.26.194-24.382-.021a12.5,12.5,0,0,1-12.169-12.653c.154-10.852,0-21.706,0-32.561a7.73,7.73,0,0,1,2.546-5.732c1.079-1.032,2.193-2.027,3.279-3.054.3-.284.769-.493.625-1.053a1.066,1.066,0,0,0,.953-.332c1.91-1.986,4.143-3.638,5.967-5.715A74.9,74.9,0,0,0,303.242,10140.777Z",
    fill: "#eeebee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2564",
    "data-name": "\\uD328\\uC2A4 2564",
    d: "M319.869,10208q-.007-10.667-.015-21.334a.735.735,0,0,0,.04-.179c.482.443.98.873,1.444,1.336q5.869,5.862,11.722,11.742a2.349,2.349,0,0,0,2.845.66,2.1,2.1,0,0,0,1.113-2.437c-.087-.727-.646-1.121-1.1-1.579-3.97-3.975-7.93-7.96-11.937-11.9-.777-.764-.78-1.218.036-1.961,1.557-1.416,3-2.956,4.49-4.445,2.606-2.609,5.2-5.229,7.82-7.822a2.378,2.378,0,0,0,.6-2.539,2.019,2.019,0,0,0-1.655-1.35,2.625,2.625,0,0,0-2.409,1.075c-2.081,2.078-4.132,4.187-6.236,6.24-2.258,2.2-4.358,4.566-6.768,6.611l.019-.088q-.01-11.6-.022-23.2c1.8-.028,3.6-.063,5.395-.081,2.811-.026,5.629.075,8.431-.09a4.713,4.713,0,0,0,4.635-5.027,4.829,4.829,0,0,0-5.135-4.544l-13.309-.057v-13.33c6.06-.007,12.147-.479,18.173.2a12.329,12.329,0,0,1,11,12.555q.09,24.4,0,48.8a12.716,12.716,0,0,1-13.09,12.783C330.593,10208.044,325.231,10208.015,319.869,10208Z",
    fill: "#dad9eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2565",
    "data-name": "\\uD328\\uC2A4 2565",
    d: "M296.689,10146.879c-1.824,2.077-4.057,3.729-5.967,5.715a1.066,1.066,0,0,1-.953.332c-.438-.427-.883-.846-1.311-1.282-.774-.788-1.383-1.717-2.827-1.087a1.658,1.658,0,0,1-2.033-1.049,2.02,2.02,0,0,1,.248-2.446c2.21-2.239,4.466-4.434,6.7-6.646a3.737,3.737,0,0,0,1.007,1.2Q294.116,10144.251,296.689,10146.879Z",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2566",
    "data-name": "\\uD328\\uC2A4 2566",
    d: "M296.689,10146.879q-2.566-2.634-5.132-5.268a3.737,3.737,0,0,1-1.007-1.2q2.9-2.952,5.807-5.9a2.151,2.151,0,0,1,2.953-.486,2,2,0,0,1,.728,2.764c-.29.567.024.788.327,1.093q1.44,1.446,2.877,2.894A74.9,74.9,0,0,1,296.689,10146.879Z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2567",
    "data-name": "\\uD328\\uC2A4 2567",
    d: "M319.894,10186.487a.735.735,0,0,1-.04.179q-4.687,4.619-9.374,9.238c-1.219,1.2-2.414,2.433-3.64,3.63-1.118,1.092-2.485,1.2-3.376.3-.968-.974-.916-2.191.25-3.367,4.053-4.086,8.109-8.171,12.221-12.2.808-.792.733-1.2-.029-1.951-4.075-4-8.09-8.066-12.137-12.1a2.29,2.29,0,0,1-.722-2.82,2.169,2.169,0,0,1,3.623-.41c2.875,2.842,5.708,5.725,8.588,8.561a60.2,60.2,0,0,0,4.618,4.476l-.021.088Z",
    fill: "#50ba32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2568",
    "data-name": "\\uD328\\uC2A4 2568",
    d: "M319.894,10186.487l-.039-6.367c2.411-2.045,4.511-4.409,6.769-6.611,2.1-2.054,4.155-4.162,6.236-6.24a2.625,2.625,0,0,1,2.409-1.075,2.019,2.019,0,0,1,1.655,1.35,2.378,2.378,0,0,1-.6,2.539c-2.62,2.594-5.214,5.213-7.82,7.822-1.489,1.489-2.933,3.029-4.49,4.445-.816.743-.813,1.2-.036,1.961,4.007,3.938,7.967,7.924,11.937,11.9.457.458,1.016.853,1.1,1.579a2.1,2.1,0,0,1-1.113,2.438,2.349,2.349,0,0,1-2.845-.66q-5.838-5.9-11.722-11.742C320.874,10187.36,320.376,10186.931,319.894,10186.487Z",
    fill: "#41a520"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1255",
    "data-name": "\\uADF8\\uB8F9 1255",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1253",
    "data-name": "\\uADF8\\uB8F9 1253"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_295",
    "data-name": "\\uC0AC\\uAC01\\uD615 295",
    width: 70.6,
    height: 95.5,
    transform: "translate(438.271 10113.019)",
    fill: "#50ba32"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_296",
    "data-name": "\\uC0AC\\uAC01\\uD615 296",
    width: 70.6,
    height: 3.714,
    transform: "translate(438.271 10113.019)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_297",
    "data-name": "\\uC0AC\\uAC01\\uD615 297",
    width: 70.6,
    height: 3.714,
    transform: "translate(438.271 10204.805)",
    fill: "#bcbec0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1252",
    "data-name": "\\uADF8\\uB8F9 1252"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_26",
    "data-name": "\\uD0C0\\uC6D0 26",
    cx: 5.776,
    cy: 5.222,
    rx: 5.776,
    ry: 5.222,
    transform: "translate(467.794 10129.857)",
    fill: "#808285"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_27",
    "data-name": "\\uD0C0\\uC6D0 27",
    cx: 5.263,
    cy: 4.758,
    rx: 5.263,
    ry: 4.758,
    transform: "translate(468.308 10130.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2569",
    "data-name": "\\uD328\\uC2A4 2569",
    d: "M471.844,10130.9l2.573,4.871-.847.234-.847.233Z",
    fill: "#ed1c24"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1254",
    "data-name": "\\uADF8\\uB8F9 1254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2570",
    "data-name": "\\uD328\\uC2A4 2570",
    d: "M484.176,10186.851a17.408,17.408,0,0,0,6.662-6.252c3.224-5.409,3.363-10.928.26-16.4a17.9,17.9,0,0,0-10.748-8.271,6.329,6.329,0,0,1-1.238-.367c-.278-.158-.423-.508-.627-.772.335-.111.746-.4.994-.307a35.941,35.941,0,0,1,5.507,2.134c11.034,6.135,12.9,19.766,3.913,28.277-1.017.964-2.2,1.785-3.37,2.728l3.557.813c.2.046.458.03.582.142a4.793,4.793,0,0,1,.574.743c-.3.127-.647.407-.91.356-1.707-.332-3.394-.748-5.1-1.11-.591-.126-1.2-.181-1.874-.278.631-2.243,1.182-4.289,1.806-6.317.076-.246.539-.4.823-.591.136.3.44.637.381.905-.265,1.213-.635,2.407-.964,3.607C484.341,10186.143,484.286,10186.4,484.176,10186.851Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2571",
    "data-name": "\\uD328\\uC2A4 2571",
    d: "M463.124,10156.688c-1.385-.292-2.7-.53-3.981-.865-.324-.084-.792-.49-.774-.722.046-.574.591-.51,1.08-.4,2.2.5,4.407,1,6.74,1.52-.6,2.113-1.171,4.2-1.8,6.271-.065.212-.484.335-.739.5-.159-.291-.5-.614-.446-.866.27-1.24.647-2.46.982-3.687.066-.243.114-.49.2-.883a16.454,16.454,0,0,0-4.425,3.348c-5.22,5.515-6.186,13.051-2.377,19.447a18.041,18.041,0,0,0,10.548,8.047,8.992,8.992,0,0,1,1.406.417c.259.133.379.486.561.74-.3.124-.667.414-.9.346a30.62,30.62,0,0,1-4.005-1.336c-12.26-5.506-15.014-20.094-5.5-29.106C460.708,10158.5,461.889,10157.678,463.124,10156.688Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_28",
    "data-name": "\\uD0C0\\uC6D0 28",
    cx: 11.52,
    cy: 10.415,
    rx: 11.52,
    ry: 10.415,
    transform: "translate(462.844 10161.968)",
    fill: "#0091c4",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.867
  }), /*#__PURE__*/React.createElement("text", {
    id: "H2",
    transform: "translate(468.322 10173.897)",
    fill: "#fff",
    fontSize: 9.887,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H2")))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1287",
    "data-name": "\\uADF8\\uB8F9 1287",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1256",
    "data-name": "\\uADF8\\uB8F9 1256"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_298",
    "data-name": "\\uC0AC\\uAC01\\uD615 298",
    width: 4.909,
    height: 1.418,
    transform: "translate(612.144 10152.126) rotate(90)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1257",
    "data-name": "\\uADF8\\uB8F9 1257"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_299",
    "data-name": "\\uC0AC\\uAC01\\uD615 299",
    width: 4.909,
    height: 1.532,
    transform: "translate(612.144 10194.421) rotate(90)",
    fill: "#414042"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1258",
    "data-name": "\\uADF8\\uB8F9 1258"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_300",
    "data-name": "\\uC0AC\\uAC01\\uD615 300",
    width: 89.97,
    height: 62.33,
    transform: "translate(612.144 10144.107)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1259",
    "data-name": "\\uADF8\\uB8F9 1259"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_301",
    "data-name": "\\uC0AC\\uAC01\\uD615 301",
    width: 59.106,
    height: 86.745,
    transform: "translate(700.502 10145.72) rotate(90)",
    fill: "#bcbec0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1260",
    "data-name": "\\uADF8\\uB8F9 1260"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_302",
    "data-name": "\\uC0AC\\uAC01\\uD615 302",
    width: 0.655,
    height: 2.754,
    transform: "translate(610.071 10153.331)",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1286",
    "data-name": "\\uADF8\\uB8F9 1286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1276",
    "data-name": "\\uADF8\\uB8F9 1276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1261",
    "data-name": "\\uADF8\\uB8F9 1261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2572",
    "data-name": "\\uD328\\uC2A4 2572",
    d: "M698.328,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1262",
    "data-name": "\\uADF8\\uB8F9 1262"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2573",
    "data-name": "\\uD328\\uC2A4 2573",
    d: "M692.683,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.681-1.209-1.681-2.687v-48.313c0-1.479.756-2.687,1.681-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1263",
    "data-name": "\\uADF8\\uB8F9 1263"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2574",
    "data-name": "\\uD328\\uC2A4 2574",
    d: "M687.037,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1264",
    "data-name": "\\uADF8\\uB8F9 1264"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2575",
    "data-name": "\\uD328\\uC2A4 2575",
    d: "M681.392,10199.429c0,1.479-.756,2.688-1.681,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.681,1.209,1.681,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1265",
    "data-name": "\\uADF8\\uB8F9 1265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2576",
    "data-name": "\\uD328\\uC2A4 2576",
    d: "M675.746,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1266",
    "data-name": "\\uADF8\\uB8F9 1266"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2577",
    "data-name": "\\uD328\\uC2A4 2577",
    d: "M670.1,10199.429c0,1.479-.757,2.688-1.681,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.681,1.209,1.681,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1267",
    "data-name": "\\uADF8\\uB8F9 1267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2578",
    "data-name": "\\uD328\\uC2A4 2578",
    d: "M664.455,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.681-1.209-1.681-2.687v-48.313c0-1.479.757-2.687,1.681-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1268",
    "data-name": "\\uADF8\\uB8F9 1268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2579",
    "data-name": "\\uD328\\uC2A4 2579",
    d: "M658.809,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1269",
    "data-name": "\\uADF8\\uB8F9 1269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2580",
    "data-name": "\\uD328\\uC2A4 2580",
    d: "M653.164,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.681-1.209-1.681-2.687v-48.313c0-1.479.756-2.687,1.681-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1270",
    "data-name": "\\uADF8\\uB8F9 1270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2581",
    "data-name": "\\uD328\\uC2A4 2581",
    d: "M647.518,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1271",
    "data-name": "\\uADF8\\uB8F9 1271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2582",
    "data-name": "\\uD328\\uC2A4 2582",
    d: "M641.873,10199.429c0,1.479-.756,2.688-1.681,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.681,1.209,1.681,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1272",
    "data-name": "\\uADF8\\uB8F9 1272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2583",
    "data-name": "\\uD328\\uC2A4 2583",
    d: "M636.227,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1273",
    "data-name": "\\uADF8\\uB8F9 1273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2584",
    "data-name": "\\uD328\\uC2A4 2584",
    d: "M630.582,10199.429c0,1.479-.757,2.688-1.681,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.681,1.209,1.681,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1274",
    "data-name": "\\uADF8\\uB8F9 1274"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2585",
    "data-name": "\\uD328\\uC2A4 2585",
    d: "M624.936,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1275",
    "data-name": "\\uADF8\\uB8F9 1275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2586",
    "data-name": "\\uD328\\uC2A4 2586",
    d: "M619.29,10199.429c0,1.479-.756,2.688-1.68,2.688s-1.68-1.209-1.68-2.687v-48.313c0-1.479.756-2.687,1.68-2.687s1.68,1.209,1.68,2.688Z",
    fill: "#e6e7e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1277",
    "data-name": "\\uADF8\\uB8F9 1277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2587",
    "data-name": "\\uD328\\uC2A4 2587",
    d: "M622.274,10135.836a23.129,23.129,0,0,0-.575-8.675c-1.348-4.734.059-8.617.575-8.674a22.529,22.529,0,0,0,.576,8.674c1.374,4.848-.063,8.731-.576,8.675C622.155,10135.779,622.787,10135.893,622.274,10135.836Z",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1278",
    "data-name": "\\uADF8\\uB8F9 1278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2588",
    "data-name": "\\uD328\\uC2A4 2588",
    d: "M656.765,10133.989a23.146,23.146,0,0,0-.576-8.675c-1.347-4.734.06-8.617.576-8.675a22.507,22.507,0,0,0,.576,8.675c1.374,4.848-.064,8.731-.576,8.675C656.645,10133.932,657.277,10134.046,656.765,10133.989Z",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1279",
    "data-name": "\\uADF8\\uB8F9 1279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2589",
    "data-name": "\\uD328\\uC2A4 2589",
    d: "M694.856,10133.989a23.146,23.146,0,0,0-.576-8.675c-1.348-4.734.059-8.617.576-8.675a22.494,22.494,0,0,0,.575,8.675c1.374,4.848-.063,8.731-.575,8.675C694.736,10133.932,695.368,10134.046,694.856,10133.989Z",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1280",
    "data-name": "\\uADF8\\uB8F9 1280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2590",
    "data-name": "\\uD328\\uC2A4 2590",
    d: "M680.959,10103.784a22.489,22.489,0,0,0,.575,8.674c1.374,4.848-.063,8.732-.575,8.675a23.144,23.144,0,0,0-.576-8.675C679.035,10107.724,680.442,10103.841,680.959,10103.784Z",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1281",
    "data-name": "\\uADF8\\uB8F9 1281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2591",
    "data-name": "\\uD328\\uC2A4 2591",
    d: "M664.613,10103.019a22.538,22.538,0,0,0,.576,8.676c1.374,4.847-.063,8.73-.576,8.674a23.125,23.125,0,0,0-.575-8.674C662.69,10106.96,664.1,10103.076,664.613,10103.019Z",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1282",
    "data-name": "\\uADF8\\uB8F9 1282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2592",
    "data-name": "\\uD328\\uC2A4 2592",
    d: "M673.824,10122.965a22.528,22.528,0,0,0,.576,8.674c1.374,4.849-.063,8.731-.576,8.675a23.155,23.155,0,0,0-.575-8.675C671.9,10126.905,673.308,10123.021,673.824,10122.965Z",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1283",
    "data-name": "\\uADF8\\uB8F9 1283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2593",
    "data-name": "\\uD328\\uC2A4 2593",
    d: "M644.948,10103.019a22.539,22.539,0,0,0,.576,8.676c1.374,4.847-.063,8.73-.576,8.674a23.127,23.127,0,0,0-.575-8.674C643.025,10106.96,644.432,10103.076,644.948,10103.019Z",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1284",
    "data-name": "\\uADF8\\uB8F9 1284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2594",
    "data-name": "\\uD328\\uC2A4 2594",
    d: "M637.465,10122.2a22.5,22.5,0,0,0,.575,8.675c1.374,4.847-.063,8.73-.575,8.674a23.141,23.141,0,0,0-.576-8.674C635.541,10126.138,636.949,10122.254,637.465,10122.2Z",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1285",
    "data-name": "\\uADF8\\uB8F9 1285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2595",
    "data-name": "\\uD328\\uC2A4 2595",
    d: "M626.523,10103.019a22.5,22.5,0,0,0,.575,8.676c1.374,4.847-.063,8.73-.575,8.674a23.14,23.14,0,0,0-.576-8.674C624.6,10106.96,626.007,10103.076,626.523,10103.019Z",
    fill: "#ed1c24"
  }))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1288",
    "data-name": "\\uADF8\\uB8F9 1288",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_303",
    "data-name": "\\uC0AC\\uAC01\\uD615 303",
    width: 93,
    height: 149,
    rx: 11.833,
    transform: "translate(608.37 9887.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_304",
    "data-name": "\\uC0AC\\uAC01\\uD615 304",
    width: 28.711,
    height: 23,
    rx: 2.583,
    transform: "translate(640.515 10025.019)",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1289",
    "data-name": "\\uADF8\\uB8F9 1289",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2596",
    "data-name": "\\uD328\\uC2A4 2596",
    d: "M645.437,9921.556a11.478,11.478,0,0,1,1.033.98h0A11.478,11.478,0,0,0,645.437,9921.556Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2597",
    "data-name": "\\uD328\\uC2A4 2597",
    d: "M648.259,9930.23a8.371,8.371,0,0,1-.306,1.048A8.371,8.371,0,0,0,648.259,9930.23Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2598",
    "data-name": "\\uD328\\uC2A4 2598",
    d: "M648.259,9930.23a8.316,8.316,0,0,0-1.545-7.16l-.095-.209.095.209A8.316,8.316,0,0,1,648.259,9930.23Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2599",
    "data-name": "\\uD328\\uC2A4 2599",
    d: "M647.953,9931.278c-.07.191-.149.379-.232.562C647.8,9931.657,647.883,9931.47,647.953,9931.278Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2600",
    "data-name": "\\uD328\\uC2A4 2600",
    d: "M671.919,9928.515a13.726,13.726,0,0,0-7.887-8.319,16.342,16.342,0,0,0-3.05-.778.445.445,0,0,1-.429-.312,20.681,20.681,0,0,0-8.494-9.714c-.174-.07-.352-.133-.521-.213a15.446,15.446,0,0,0-5.04-1.69v0q-.015,7.522-.027,15.046h0c.049.108.1.217.148.325l.095.209a8.711,8.711,0,0,1,1.239,8.208c-.07.191-.149.379-.232.562-.065.143-.132.283-.205.419a6.472,6.472,0,0,1-1.017,1.42,1.7,1.7,0,0,1-.013.174q.015,6.53.03,13.058c3.785.011,7.57.01,11.354.041a17,17,0,0,0,4-.393A13.814,13.814,0,0,0,671.919,9928.515Zm-13.5,9.43c0,.354-.3.359-.565.359q-2.979,0-5.958,0c-.22,0-.523.012-.525-.283-.006-.874-.277-1.776.385-2.575,1.02-1.23,2-2.492,2.979-3.756.244-.313.623-.692.249-1.1s-.738-.192-1.028.2c-.145.2-.348.066-.53.034-.439-.077-.878-.156-1.319-.222-1.5-.218-1.575-.372-.806-1.68a3.777,3.777,0,0,1,6.814,3.118c-.336,1.184-1.244,1.99-1.91,3.061a2.479,2.479,0,0,0,.285.091c.62.089,1.522-.31,1.809.206C658.7,9936.122,658.423,9937.084,658.419,9937.944Z",
    fill: "#b1d5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2601",
    "data-name": "\\uD328\\uC2A4 2601",
    d: "M641.348,9936.842c-4.882,1.086-10.089-3.08-10.307-8.069a8.783,8.783,0,0,1,8.924-9.312,8.589,8.589,0,0,1,5.472,2.1,11.478,11.478,0,0,1,1.033.98q.014-7.522.028-15.046v0a9.054,9.054,0,0,0-1.925-.376c.965,3.677-.738,7-4.277,8.044a6.262,6.262,0,0,1-8.052-4.99,17.708,17.708,0,0,0-6.343,6.507c-.483.79-.618,1.808-1.358,2.4a17.945,17.945,0,0,0-2.1,1.972,14.76,14.76,0,0,0-3.771,13.321,15.272,15.272,0,0,0,14.468,12.531c4.443.259,8.915.024,13.374.013q-.015-6.529-.03-13.058A9.85,9.85,0,0,1,641.348,9936.842Z",
    fill: "#cfe5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2602",
    "data-name": "\\uD328\\uC2A4 2602",
    d: "M646.471,9922.536q.012-7.522.027-15.046-.015,7.522-.028,15.046Z",
    fill: "#b1d5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2603",
    "data-name": "\\uD328\\uC2A4 2603",
    d: "M640.3,9915.156c3.539-1.045,5.242-4.367,4.277-8.044-9.439-.169-12.329,3.054-12.329,3.054A6.262,6.262,0,0,0,640.3,9915.156Z",
    fill: "#cfe5f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2604",
    "data-name": "\\uD328\\uC2A4 2604",
    d: "M645.437,9921.556a8.589,8.589,0,0,0-5.472-2.1,8.783,8.783,0,0,0-8.924,9.313c.218,4.989,5.425,9.155,10.307,8.069a9.85,9.85,0,0,0,5.138-2.989,1.7,1.7,0,0,0,.013-.174q0-4.811,0-9.622c0-.336-.125-.716.212-.986l-.095-.209-.149-.324h0A11.478,11.478,0,0,0,645.437,9921.556Zm-.118,6.7a5.478,5.478,0,0,1-5.6,5.521,5.543,5.543,0,1,1,.071-11.086A5.5,5.5,0,0,1,645.319,9928.26Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2605",
    "data-name": "\\uD328\\uC2A4 2605",
    d: "M646.619,9922.861c-.05-.108-.1-.217-.148-.325h0Z",
    fill: "#fdfaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2606",
    "data-name": "\\uD328\\uC2A4 2606",
    d: "M656.49,9935.192a2.479,2.479,0,0,1-.285-.091c.666-1.07,1.574-1.877,1.91-3.061a3.777,3.777,0,0,0-6.814-3.118c-.769,1.308-.693,1.462.806,1.68.441.065.88.145,1.319.222.182.032.385.164.53-.034.29-.4.658-.605,1.028-.2s-.005.784-.249,1.1c-.979,1.264-1.959,2.525-2.979,3.756-.662.8-.391,1.7-.385,2.575,0,.295.305.283.525.283q2.979.007,5.958,0c.262,0,.563-.006.565-.359,0-.86.283-1.822-.12-2.546C658.012,9934.883,657.11,9935.281,656.49,9935.192Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2607",
    "data-name": "\\uD328\\uC2A4 2607",
    d: "M646.714,9923.07c-.337.271-.211.65-.212.986q-.012,4.811,0,9.622a6.472,6.472,0,0,0,1.017-1.42c.073-.136.14-.276.205-.419.083-.183.162-.37.232-.562a8.711,8.711,0,0,0-1.239-8.208Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2608",
    "data-name": "\\uD328\\uC2A4 2608",
    d: "M647.721,9931.84c-.065.143-.132.283-.205.419C647.589,9932.123,647.656,9931.982,647.721,9931.84Z",
    fill: "#f5efea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2609",
    "data-name": "\\uD328\\uC2A4 2609",
    d: "M639.788,9922.694a5.543,5.543,0,1,0-.071,11.086,5.543,5.543,0,1,0,.071-11.086Z",
    fill: "#cfe5f6"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1292",
    "data-name": "\\uADF8\\uB8F9 1292",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1290",
    "data-name": "\\uADF8\\uB8F9 1290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2610",
    "data-name": "\\uD328\\uC2A4 2610",
    d: "M664.224,9989.69a10.155,10.155,0,0,1,.906.859h0A10.155,10.155,0,0,0,664.224,9989.69Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2611",
    "data-name": "\\uD328\\uC2A4 2611",
    d: "M666.7,9997.3a7.483,7.483,0,0,1-.269.919A7.483,7.483,0,0,0,666.7,9997.3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2612",
    "data-name": "\\uD328\\uC2A4 2612",
    d: "M666.7,9997.3a7.3,7.3,0,0,0-1.355-6.279l-.084-.183.084.183A7.3,7.3,0,0,1,666.7,9997.3Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2613",
    "data-name": "\\uD328\\uC2A4 2613",
    d: "M666.43,9998.216c-.061.168-.13.331-.2.493C666.3,9998.547,666.369,9998.384,666.43,9998.216Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2614",
    "data-name": "\\uD328\\uC2A4 2614",
    d: "M687.446,9995.792a12.038,12.038,0,0,0-6.916-7.3,14.348,14.348,0,0,0-2.675-.681.391.391,0,0,1-.375-.274,18.139,18.139,0,0,0-7.449-8.518c-.153-.062-.309-.116-.457-.187a13.574,13.574,0,0,0-4.42-1.482v0l-.024,13.194h0l.13.285.084.183a7.3,7.3,0,0,1,1.355,6.279,7.483,7.483,0,0,1-.269.919c-.061.168-.13.331-.2.493-.057.124-.116.247-.18.367a5.706,5.706,0,0,1-.892,1.245c0,.051-.005.1-.011.152q.014,5.726.026,11.45c3.319.009,6.638.008,9.957.035a14.968,14.968,0,0,0,3.509-.343A12.114,12.114,0,0,0,687.446,9995.792Zm-11.838,8.269c0,.312-.266.315-.495.316q-2.613,0-5.225,0c-.193,0-.458.01-.46-.249-.005-.766-.244-1.558.337-2.259.894-1.078,1.754-2.186,2.613-3.292.214-.276.546-.608.218-.963s-.648-.169-.9.178c-.127.173-.3.058-.464.029-.385-.067-.77-.138-1.157-.193-1.314-.192-1.381-.328-.707-1.474a3.312,3.312,0,0,1,5.976,2.733,11.234,11.234,0,0,1-1.676,2.686,2.4,2.4,0,0,0,.251.079c.543.077,1.334-.271,1.586.181C675.856,10002.463,675.612,10003.307,675.608,10004.061Z",
    fill: "#75b5e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2615",
    "data-name": "\\uD328\\uC2A4 2615",
    d: "M660.638,10003.095c-4.281.952-8.846-2.7-9.038-7.077a7.7,7.7,0,0,1,7.826-8.166,7.531,7.531,0,0,1,4.8,1.839,10.155,10.155,0,0,1,.906.859l.024-13.194v0a8.072,8.072,0,0,0-1.688-.329,5.581,5.581,0,1,1-10.811,2.678,15.536,15.536,0,0,0-5.563,5.706c-.423.692-.541,1.584-1.19,2.1a15.728,15.728,0,0,0-1.84,1.729,12.94,12.94,0,0,0-3.306,11.681,13.388,13.388,0,0,0,12.686,10.989c3.9.227,7.818.021,11.728.012q-.012-5.725-.026-11.45A8.631,8.631,0,0,1,660.638,10003.095Z",
    fill: "#94c5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2616",
    "data-name": "\\uD328\\uC2A4 2616",
    d: "M665.13,9990.55l.024-13.194-.024,13.194Z",
    fill: "#b1d5f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2617",
    "data-name": "\\uD328\\uC2A4 2617",
    d: "M659.716,9984.078a5.511,5.511,0,0,0,3.75-7.054c-8.277-.148-10.811,2.678-10.811,2.678A5.491,5.491,0,0,0,659.716,9984.078Z",
    fill: "#94c5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2618",
    "data-name": "\\uD328\\uC2A4 2618",
    d: "M664.224,9989.69a7.531,7.531,0,0,0-4.8-1.839,7.7,7.7,0,0,0-7.826,8.166c.192,4.376,4.757,8.029,9.038,7.077a8.631,8.631,0,0,0,4.506-2.621c.006-.051.01-.1.011-.152,0-2.813,0-5.625,0-8.437,0-.295-.11-.628.186-.866l-.084-.183-.13-.285h0A10.155,10.155,0,0,0,664.224,9989.69Zm-.1,5.879a4.8,4.8,0,0,1-4.913,4.84,4.861,4.861,0,1,1,.062-9.721A4.823,4.823,0,0,1,664.121,9995.569Z",
    fill: "#94c5ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2619",
    "data-name": "\\uD328\\uC2A4 2619",
    d: "M665.26,9990.835l-.13-.285h0Z",
    fill: "#fdfaf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2620",
    "data-name": "\\uD328\\uC2A4 2620",
    d: "M673.917,10001.648a2.4,2.4,0,0,1-.251-.079,11.234,11.234,0,0,0,1.676-2.686,3.312,3.312,0,0,0-5.976-2.733c-.674,1.146-.607,1.281.707,1.474.387.056.772.126,1.157.193.159.028.337.144.464-.029.254-.347.577-.531.9-.178s0,.687-.218.963c-.859,1.106-1.719,2.214-2.613,3.292-.581.7-.342,1.493-.337,2.259,0,.259.267.248.46.249q2.613.006,5.225,0c.229,0,.493,0,.495-.316,0-.754.248-1.6-.1-2.231C675.251,10001.377,674.46,10001.726,673.917,10001.648Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2621",
    "data-name": "\\uD328\\uC2A4 2621",
    d: "M665.344,9991.018c-.3.238-.185.571-.186.866-.007,2.813,0,5.624,0,8.438a5.706,5.706,0,0,0,.892-1.245c.064-.12.123-.243.18-.367.073-.162.142-.325.2-.493a7.483,7.483,0,0,0,.269-.919A7.3,7.3,0,0,0,665.344,9991.018Z",
    fill: "#75b5e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2622",
    "data-name": "\\uD328\\uC2A4 2622",
    d: "M666.227,9998.709c-.057.124-.116.247-.18.367C666.111,9998.956,666.17,9998.833,666.227,9998.709Z",
    fill: "#f5efea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2623",
    "data-name": "\\uD328\\uC2A4 2623",
    d: "M659.27,9990.688a4.861,4.861,0,1,0-.062,9.721,4.86,4.86,0,1,0,.062-9.721Z",
    fill: "#94c5ec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1291",
    "data-name": "\\uADF8\\uB8F9 1291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2624",
    "data-name": "\\uD328\\uC2A4 2624",
    d: "M655.073,10004.9a.515.515,0,0,1-.344-.09.472.472,0,0,1-.1-.354v-16.2a.392.392,0,0,1,.444-.442H657.2a.392.392,0,0,1,.444.442v6.479h6.1v-6.479a.391.391,0,0,1,.443-.442h2.13a.392.392,0,0,1,.444.442v16.2a.476.476,0,0,1-.1.354.517.517,0,0,1-.344.09h-2.13a.517.517,0,0,1-.344-.09.476.476,0,0,1-.1-.354v-6.922h-6.1v6.922a.472.472,0,0,1-.1.354.515.515,0,0,1-.344.09Z",
    fill: "#231f20"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1293",
    "data-name": "\\uADF8\\uB8F9 1293",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2625",
    "data-name": "\\uD328\\uC2A4 2625",
    d: "M657.136,9963.639v5.488c0,.218-.041.359-.123.423a.644.644,0,0,1-.4.1h-2.4a.644.644,0,0,1-.4-.1c-.082-.063-.122-.205-.122-.423v-5.488h-5.461a.459.459,0,0,1-.519-.519v-2.212a.459.459,0,0,1,.519-.519H653.7v-5.434a.459.459,0,0,1,.518-.52h2.4a.459.459,0,0,1,.519.52v5.434h5.433a.537.537,0,0,1,.424.122.657.657,0,0,1,.1.4v2.212a.654.654,0,0,1-.1.4c-.064.082-.2.123-.424.123Z",
    fill: "#f15a24"
  }))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    id: "\\uC778\\uBC84\\uD130",
    transform: "translate(572.89 152.818)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "NanumGothicExtraBold, NanumGothic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC778\uBC84\uD130"))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_305",
    "data-name": "\\uC0AC\\uAC01\\uD615 305",
    width: 67,
    height: 67,
    rx: 6.389,
    transform: "translate(763.162 60.234)",
    fill: "#f2f2f2"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1294",
    "data-name": "\\uADF8\\uB8F9 1294",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2626",
    "data-name": "\\uD328\\uC2A4 2626",
    d: "M1080.549,9962.36c-1.393.008-2.787.055-4.179.013a3,3,0,0,1-2.876-2.95q-.021-11.405,0-22.812a3.039,3.039,0,0,1,3.019-3q8.18-.019,16.36,0a3.031,3.031,0,0,1,2.99,3.028q.016,11.361,0,22.722a3,3,0,0,1-2.906,3.014c-1.391.039-2.785-.006-4.178-.014l-1.808.015Zm9.675-6.351q-6.047-.013-12.091-.027c-1.63,0-1.63,0-1.452,1.631-.194,1.645-.194,1.645,1.439,1.645h12.189c2.511,0,2.5,0,2.444-2.546-.011-.533-.132-.785-.712-.739C1091.438,9956.021,1090.829,9956,1090.224,9956.01Zm-.012-19.219c-4.326-.112-8.651-.068-12.977.01-.539.01-.547.344-.549.732-.012,1.573-.045,3.146-.044,4.719,0,2.692.021,5.383.033,8.075-.022.542-.012,1.088-.073,1.626-.081.71.171.928.9.923q7.172-.05,14.342,0c.719,0,.921-.2.916-.915-.032-4.326-.016-8.653-.016-12.979C1092.745,9936.5,1092.745,9936.5,1090.212,9936.791Z",
    fill: "#5e87c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2627",
    "data-name": "\\uD328\\uC2A4 2627",
    d: "M1052.35,9951.3a9.176,9.176,0,0,1-4.525-7.7,9.547,9.547,0,0,1,7.858-9.866,7.857,7.857,0,0,1,4.711.38,2.969,2.969,0,0,0,.824.953,9.532,9.532,0,0,1-8.131,16.016C1052.824,9951.044,1052.533,9951.017,1052.35,9951.3Zm4.325-14.123-.219-.075q-1.8,3.6-3.6,7.2c-.2.4-.041.564.37.564.575,0,1.153.036,1.725-.008a.957.957,0,0,1,1.123.753,28.591,28.591,0,0,0,1.335,3.736,2.882,2.882,0,0,0,.636-1.114c.738-1.622,1.455-3.255,2.178-4.884.442-1,.437-1-.683-1-.424,0-.85-.029-1.271.007-.68.06-.944-.177-1.007-.9C1057.142,9940.018,1056.88,9938.6,1056.675,9937.177Z",
    fill: "#f5b941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2628",
    "data-name": "\\uD328\\uC2A4 2628",
    d: "M1052.35,9951.3c.183-.283.474-.256.737-.219a9.532,9.532,0,0,0,8.131-16.016,2.969,2.969,0,0,1-.824-.953c3.168.75,6.113,4.188,6.537,7.632a9.6,9.6,0,0,1-9,11.063A8.416,8.416,0,0,1,1052.35,9951.3Z",
    fill: "#f3a93e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2629",
    "data-name": "\\uD328\\uC2A4 2629",
    d: "M1085.458,9967.207c.019,2.651.339,5.333-.673,7.889a10.908,10.908,0,0,1-9.343,7.276,11.144,11.144,0,0,1-12.237-9.24,11.948,11.948,0,0,1-.157-4.322,5,5,0,0,0,1.5.051,22.8,22.8,0,0,0,.352,4.589,9.613,9.613,0,0,0,18.965-2.159c-.011-1.361.021-2.722.034-4.083Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2630",
    "data-name": "\\uD328\\uC2A4 2630",
    d: "M1064.545,9968.86a5,5,0,0,1-1.5-.051,4.783,4.783,0,0,1-3.917-3.907c1.692,0,3.384.006,5.075-.01,1.383-.013,2-.632,2-1.982,0-1.208,0-2.416,0-3.624l.862-.044c1.537.039,1.537.039,1.537,1.611,0,1.058.005,2.114,0,3.172a4.7,4.7,0,0,1-3.639,4.684A4.3,4.3,0,0,0,1064.545,9968.86Z",
    fill: "#5f87c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2631",
    "data-name": "\\uD328\\uC2A4 2631",
    d: "M1066.2,9959.286c0,1.208.007,2.416,0,3.624,0,1.351-.618,1.97-2,1.982-1.691.016-3.383.008-5.075.01a35.068,35.068,0,0,1-.15-5.2c-.015-.368.211-.447.523-.442.36.006.72-.007,1.08-.011h4.893Z",
    fill: "#789fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2632",
    "data-name": "\\uD328\\uC2A4 2632",
    d: "M1080.549,9962.36l6.421.015a3.949,3.949,0,0,1-2.676,3.041,4.64,4.64,0,0,1-3.009-.148C1080.542,9964.425,1080.749,9963.341,1080.549,9962.36Z",
    fill: "#4c6cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2633",
    "data-name": "\\uD328\\uC2A4 2633",
    d: "M1081.285,9965.268a4.64,4.64,0,0,0,3.009.148,3.949,3.949,0,0,0,2.676-3.041l1.808-.015c-.037.419-.058.84-.113,1.257a4.1,4.1,0,0,1-3.207,3.59H1083.9A3.972,3.972,0,0,1,1081.285,9965.268Z",
    fill: "#3d5a93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2634",
    "data-name": "\\uD328\\uC2A4 2634",
    d: "M1062.207,9959.245h-1.623c0-1.144.034-2.286-.013-3.427-.03-.725.441-.561.83-.562s.852-.165.82.562C1062.169,9956.958,1062.207,9958.1,1062.207,9959.245Z",
    fill: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2635",
    "data-name": "\\uD328\\uC2A4 2635",
    d: "M1066.2,9959.286l-.726-.041c0-1.147.034-2.3-.014-3.441-.027-.649.364-.569.75-.546s.884-.2.859.543c-.037,1.146-.008,2.294-.007,3.441Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2636",
    "data-name": "\\uD328\\uC2A4 2636",
    d: "M1076.675,9950.327c-.012-2.692-.032-5.383-.033-8.075,0-1.573.032-3.146.044-4.719,0-.389.01-.723.549-.732,4.326-.078,8.651-.122,12.977-.01.006,3.817.019,7.635.011,11.453a2.191,2.191,0,0,1-2.093,2.093C1084.311,9950.346,1080.493,9950.332,1076.675,9950.327Zm9.731-9.976a3.96,3.96,0,0,0-3.071-.188,4.737,4.737,0,0,0-3.453,4,4.579,4.579,0,0,0,2.113,4.551,4.4,4.4,0,0,0,5.022.262,4.767,4.767,0,0,0-.611-8.626Z",
    fill: "#f0f0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2637",
    "data-name": "\\uD328\\uC2A4 2637",
    d: "M1076.675,9950.327c3.818,0,7.636.019,11.455.01a2.191,2.191,0,0,0,2.093-2.093c.008-3.818-.005-7.636-.011-11.453,2.533-.291,2.533-.291,2.533,2.189,0,4.326-.016,8.653.016,12.979.005.719-.2.92-.916.915q-7.17-.047-14.342,0c-.73,0-.982-.213-.9-.923C1076.663,9951.415,1076.653,9950.869,1076.675,9950.327Z",
    fill: "#dbe1f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2638",
    "data-name": "\\uD328\\uC2A4 2638",
    d: "M1090.224,9956.01c.6-.009,1.214.012,1.817-.037.58-.046.7.206.712.739.052,2.546.067,2.546-2.444,2.546H1078.12c-1.633,0-1.633,0-1.439-1.645l11.909.007C1090.219,9957.62,1090.233,9957.606,1090.224,9956.01Z",
    fill: "#dfe5f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2639",
    "data-name": "\\uD328\\uC2A4 2639",
    d: "M1090.224,9956.01c.009,1.6-.005,1.61-1.634,1.61l-11.909-.007c-.178-1.631-.178-1.635,1.452-1.631Q1084.178,9955.994,1090.224,9956.01Z",
    fill: "#f0f0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2640",
    "data-name": "\\uD328\\uC2A4 2640",
    d: "M1056.675,9937.177c.2,1.423.467,2.841.591,4.271.063.726.327.962,1.007.9.421-.036.847-.008,1.271-.007,1.12,0,1.125.009.683,1-.723,1.629-1.44,3.262-2.178,4.884a2.882,2.882,0,0,1-.636,1.114,28.591,28.591,0,0,1-1.335-3.736.957.957,0,0,0-1.123-.753c-.572.044-1.15.008-1.725.008-.411,0-.569-.166-.37-.564q1.8-3.6,3.6-7.2Z",
    fill: "#fbe594"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2641",
    "data-name": "\\uD328\\uC2A4 2641",
    d: "M1081.995,9948.716a4.579,4.579,0,0,1-2.113-4.551,4.737,4.737,0,0,1,3.453-4,3.96,3.96,0,0,1,3.071.188.842.842,0,0,0,.286.543,4.756,4.756,0,0,1-2.449,7.741A9.383,9.383,0,0,1,1081.995,9948.716Zm1.845-3.946c.186-.745-.224-.8-.834-.817-.645-.016-.793.2-.8.814-.006.649.14.88.838.871C1083.722,9945.631,1083.993,9945.446,1083.84,9944.77Zm2.483-.777c-.7-.164-.863.147-.848.809.013.582.1.86.774.831.587-.024.945-.044.9-.8C1087.112,9944.221,1087.069,9943.81,1086.323,9943.992Z",
    fill: "#4c6cb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2642",
    "data-name": "\\uD328\\uC2A4 2642",
    d: "M1081.995,9948.716a9.383,9.383,0,0,0,2.248-.08,4.756,4.756,0,0,0,2.449-7.741.842.842,0,0,1-.286-.543,4.767,4.767,0,0,1,.611,8.626A4.4,4.4,0,0,1,1081.995,9948.716Z",
    fill: "#3f5b94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2643",
    "data-name": "\\uD328\\uC2A4 2643",
    d: "M1083.84,9944.77c.153.677-.118.861-.795.868-.7.009-.844-.222-.838-.871.006-.613.154-.83.8-.814C1083.616,9943.967,1084.026,9944.024,1083.84,9944.77Z",
    fill: "#f0f0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2644",
    "data-name": "\\uD328\\uC2A4 2644",
    d: "M1086.323,9943.992c.746-.183.789.229.826.837.045.759-.313.778-.9.8-.675.029-.761-.249-.774-.831C1085.46,9944.14,1085.626,9943.828,1086.323,9943.992Z",
    fill: "#f0f0f1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2645",
    "data-name": "\\uD328\\uC2A4 2645",
    d: "M559.87,9921.29l14.5-9.151-14.5-9.392Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "#0071bc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2646",
    "data-name": "\\uD328\\uC2A4 2646",
    d: "M411.87,10181.79l14.5-9.151-14.5-9.392Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "#0071bc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2647",
    "data-name": "\\uD328\\uC2A4 2647",
    d: "M559.87,9964.29l14.5-9.151-14.5-9.392Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "#0071bc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2648",
    "data-name": "\\uD328\\uC2A4 2648",
    d: "M767.87,9964.29l14.5-9.151-14.5-9.392Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "#fcee21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2649",
    "data-name": "\\uD328\\uC2A4 2649",
    d: "M644.274,10078.019l9.152,14.5,9.391-14.5Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "#f44522"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2650",
    "data-name": "\\uD328\\uC2A4 2650",
    d: "M977.87,9964.29l14.5-9.151-14.5-9.392Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "#fcee21"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_306",
    "data-name": "\\uC0AC\\uAC01\\uD615 306",
    width: 11,
    height: 33,
    transform: "translate(735.162 265.234) rotate(90)",
    fill: "url(#linear-gradient-15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2651",
    "data-name": "\\uD328\\uC2A4 2651",
    d: "M975.87,10141.846l14.5-9.152-14.5-9.392Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "#f44522"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_307",
    "data-name": "\\uC0AC\\uAC01\\uD615 307",
    width: 67,
    height: 67,
    rx: 6.389,
    transform: "translate(726.162 235.234)",
    fill: "#f2f2f2"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1296",
    "data-name": "\\uADF8\\uB8F9 1296",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2652",
    "data-name": "\\uD328\\uC2A4 2652",
    d: "M1056.269,10146.477v8.542h-17.221v-8.542h4.589a1.623,1.623,0,1,1,1.578-2v-16.718h4.774v16.718a1.624,1.624,0,1,1,1.579,2Z",
    fill: "#569ec6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2653",
    "data-name": "\\uD328\\uC2A4 2653",
    d: "M1044.227,10107.116a2.048,2.048,0,0,0-1.608.778h-6.042a2.052,2.052,0,1,0,0,2.547h1.748v3.38h2.546v-3.38h1.748a2.052,2.052,0,1,0,1.608-3.325Z",
    fill: "#495968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2654",
    "data-name": "\\uD328\\uC2A4 2654",
    d: "M1047.6,10116.956h-4.276a4.635,4.635,0,0,0-1.3-1.2h-4.856a4.633,4.633,0,0,0-1.3,1.2h-7.947v5.473h7.947a4.617,4.617,0,0,0,7.455,0h1.541v5.336h5.472v-8.072A2.736,2.736,0,0,0,1047.6,10116.956Z",
    fill: "#ff4b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2655",
    "data-name": "\\uD328\\uC2A4 2655",
    d: "M1042.026,10114.366a.545.545,0,0,0-.545-.545h-3.766a.545.545,0,0,0-.545.545v1.391h4.856Z",
    fill: "#ff4b27"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_308",
    "data-name": "\\uC0AC\\uAC01\\uD615 308",
    width: 14.211,
    height: 7.591,
    transform: "translate(1011.542 10115.896)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2656",
    "data-name": "\\uD328\\uC2A4 2656",
    d: "M1025.754,10114.363v10.658h2.169v-10.658Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1295",
    "data-name": "\\uADF8\\uB8F9 1295"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_309",
    "data-name": "\\uC0AC\\uAC01\\uD615 309",
    width: 10.426,
    height: 1.818,
    transform: "translate(1042.389 10127.219)",
    fill: "#df5c39"
  })))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_310",
    "data-name": "\\uC0AC\\uAC01\\uD615 310",
    width: 11,
    height: 33,
    transform: "translate(735.162 340.234) rotate(90)",
    fill: "url(#linear-gradient-15)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_311",
    "data-name": "\\uC0AC\\uAC01\\uD615 311",
    width: 67,
    height: 67,
    rx: 6.389,
    transform: "translate(726.162 311.234)",
    fill: "#f2f2f2"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1297",
    "data-name": "\\uADF8\\uB8F9 1297",
    transform: "translate(-276.709 -9861.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2657",
    "data-name": "\\uD328\\uC2A4 2657",
    d: "M1053.985,10206.023v17.064c.658,0,1.275-.013,1.892,0a1.213,1.213,0,0,1,1.366,1.276,23.1,23.1,0,0,1,.007,2.439,1.292,1.292,0,0,1-1.46,1.375q-18.956.006-37.913,0a1.271,1.271,0,0,1-1.428-1.32,23.117,23.117,0,0,1-.005-2.44,1.242,1.242,0,0,1,1.4-1.33c.593-.014,1.186,0,1.843,0V10206.2c-.61-.041-1.408.141-1.833-.177a7.645,7.645,0,0,1-1.948-2.233,1.457,1.457,0,0,1,.566-1.861c1.519-1.269,3.032-2.546,4.505-3.867a1.667,1.667,0,0,0,.5-1.085c.044-2.413.021-4.828.024-7.243,0-1.391.375-1.752,1.8-1.755,1.139,0,2.279-.01,3.417,0,1.084.013,1.521.456,1.533,1.531.008.723,0,1.444,0,2.365,1.228-1.045,2.312-1.965,3.394-2.887,1.279-1.092,2.552-2.188,3.835-3.274,1.1-.928,1.652-.927,2.764.021q8.448,7.2,16.89,14.416c.722.615,1.454,1.219,2.161,1.852a1.6,1.6,0,0,1,.173,2.375c-.223.272-.462.532-.69.8C1055.748,10206.39,1055.435,10206.486,1053.985,10206.023Zm-1.486,17.026v-1.032c0-5.48-.013-10.963.017-16.443a1.84,1.84,0,0,0-.724-1.582q-7.2-6.1-14.357-12.255c-.435-.374-.7-.4-1.156-.016q-7.22,6.205-14.479,12.362a1.538,1.538,0,0,0-.618,1.3c.024,5.59.014,11.18.016,16.77,0,.288.025.575.041.93h3.806c.135,0,.3.045.4-.014a1.322,1.322,0,0,0,.483-.424,19.71,19.71,0,0,1,1.08-1.972c1.394-1.871,1.431-3.08-.011-4.889a5.105,5.105,0,0,1-1.212-2.782c-.033-.383-.005-.77-.005-1.155a12.526,12.526,0,0,0-1.429,1.87c-.278.419-.616.747-1.132.411s-.381-.751-.087-1.188c.891-1.328,1.757-2.671,2.645-4,.458-.687,1-.69,1.467,0,.893,1.325,1.762,2.668,2.655,3.993.292.435.432.854-.074,1.193s-.857.023-1.137-.394c-.43-.642-.858-1.282-1.378-2.06a3.853,3.853,0,0,0,.681,3.052,8.814,8.814,0,0,1,1.34,2.371,4.351,4.351,0,0,1-.959,4.171c-.4.51-.725,1.078-1.184,1.771h8.724c.573-.938,1.016-1.8,1.589-2.572a3.232,3.232,0,0,0-.038-4.5,4.848,4.848,0,0,1-1.317-3.393c.014-.23,0-.463,0-.7a25.155,25.155,0,0,0-1.583,1.959c-.2.229-.673.216-1.022.314-.054-.359-.279-.822-.134-1.061.887-1.457,1.843-2.874,2.809-4.281a.687.687,0,0,1,1.223-.045c1.009,1.443,1.98,2.915,2.9,4.416a1.032,1.032,0,0,1-.245.944c-.133.126-.648-.013-.893-.179s-.378-.518-.563-.784c-.319-.462-.64-.922-1.039-1.5a4,4,0,0,0,1.013,3.408,4.671,4.671,0,0,1,1.181,3.6,5.358,5.358,0,0,1-1.324,2.9c-.322.428-.57.911-.937,1.509h7.813a3.018,3.018,0,0,0,.729-.015.927.927,0,0,0,.527-.348c.519-.844.954-1.743,1.509-2.562a3.059,3.059,0,0,0-.007-3.843,6.2,6.2,0,0,1-1.651-4.364c0-.021-.079-.045-.149-.082-.389.581-.782,1.163-1.17,1.748-.3.451-.632.91-1.231.5-.55-.381-.283-.841,0-1.271q1.267-1.89,2.523-3.789c.556-.837,1.038-.849,1.595-.02.845,1.261,1.674,2.532,2.518,3.793.307.46.575.942-.042,1.32-.572.35-.883-.092-1.165-.52-.418-.632-.847-1.256-1.346-1.993a3.909,3.909,0,0,0,.983,3.409,4.7,4.7,0,0,1,1.216,3.67,5.639,5.639,0,0,1-1.41,2.96,14.653,14.653,0,0,0-.829,1.373Zm4.029-19.809-19.68-16.795-19.681,16.8,1.44,1.636c.223-.175.4-.3.555-.436q8.171-6.967,16.338-13.934a1.71,1.71,0,0,1,2.595-.093q6.094,5.2,12.186,10.4c1.581,1.349,3.167,2.69,4.8,4.074Zm-.741,21.334c-.232-.023-.364-.048-.5-.048q-8.982,0-17.964,0h-11.3c-2.492,0-4.985-.014-7.477.018-.23,0-.626.25-.654.43a11.053,11.053,0,0,0-.032,1.7h37.921Zm-32.794-28.2c1.258-1.081,2.37-2.027,3.467-2.989a.871.871,0,0,0,.316-.521c.028-1.126.014-2.252.014-3.375h-3.8Z",
    fill: "#ed1c24"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_2658",
    "data-name": "\\uD328\\uC2A4 2658",
    d: "M975.87,10216.846l14.5-9.152-14.5-9.392Z",
    transform: "translate(-276.709 -9861.784)",
    fill: "#f44522"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder6);
export default __webpack_public_path__ + "static/media/placeholder6.7eb8effd55c296db46af64962c4cc49b.svg";
export { ForwardRef as ReactComponent };